module.exports = __webpack_public_path__ + "static/img/media1.17cdd33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/media1.png
// module id = DNuW
// module chunks = 8